import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackbaseCoreModule } from '@backbase/foundation-ang/core';
import { BnAppStateWidgetComponent } from './bn-app-state-widget.component';
import { AppStateCouldntLoadComponent } from './app-state-couldnt-load/app-state-couldnt-load.component';
import { AppStateNoDataComponent } from './app-state-no-data/app-state-no-data.component';

@NgModule({
  declarations: [BnAppStateWidgetComponent, AppStateCouldntLoadComponent, AppStateNoDataComponent],
  exports: [AppStateCouldntLoadComponent, AppStateNoDataComponent, BnAppStateWidgetComponent],
  imports: [
    CommonModule,
    BackbaseCoreModule.withConfig({
      classMap: { BnAppStateWidgetComponent },
    }),
  ],
})
export class BnAppStateWidgetModule {}
